import { useQuery } from '@tanstack/react-query';
import { ATIVOS_KEYS, listarCostCenters, listarLocations } from '../../api';
import { AutocompleteSelect } from '../../../../shared/components/AutocompleteSelect';

interface GlobalFiltersProps {
  costCenterId?: string;
  locationId?: string;
  onChange: (patch: { costCenterId?: string; locationId?: string }) => void;
}

export function GlobalFilters({ costCenterId, locationId, onChange }: GlobalFiltersProps) {
  const ccs = useQuery({ queryKey: ATIVOS_KEYS.masterData.costCenters, queryFn: listarCostCenters });
  const locs = useQuery({ queryKey: ATIVOS_KEYS.masterData.locations, queryFn: listarLocations });

  const costCenterOptions = [
    { value: '', label: 'Todos' },
    ...((ccs.data?.data ?? []).map((cc) => ({ value: cc.id, label: cc.name }))),
  ];

  const locationOptions = [
    { value: '', label: 'Todas' },
    ...((locs.data?.data ?? []).map((l) => ({ value: l.id, label: l.name }))),
  ];

  return (
    <div className="flex flex-wrap items-end gap-3 rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
      <div className="min-w-[200px]">
        <AutocompleteSelect
          label="Centro de custo"
          options={costCenterOptions}
          value={costCenterId ?? ''}
          onChange={(v) => onChange({ costCenterId: v || undefined })}
        />
      </div>
      <div className="min-w-[200px]">
        <AutocompleteSelect
          label="Localização"
          options={locationOptions}
          value={locationId ?? ''}
          onChange={(v) => onChange({ locationId: v || undefined })}
        />
      </div>
      {(costCenterId || locationId) && (
        <button
          type="button"
          className="ml-auto rounded border border-gray-300 px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
          onClick={() => onChange({ costCenterId: undefined, locationId: undefined })}
        >
          Limpar filtros
        </button>
      )}
    </div>
  );
}
